import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './login/logout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SplendidCRMDFService } from './services/SplendidCRMDFService';
import { AuthGuard } from './services/AuthGuardService.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TabsModule } from 'ngx-bootstrap';



export const routes: Routes = [
  {
    path: '',
    redirectTo: '/calendario',
    pathMatch: 'full',
    canActivate:[ AuthGuard ]
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [ AuthGuard ],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule',
        canActivate: [ AuthGuard ],
      },
      {
        path: 'visitas',
        loadChildren: './operacion/visitas/visitas.module#VisitasModule',
        canActivate: [ AuthGuard ]
      },
      // {
      //   path: 'promociones',
      //   loadChildren: './operacion/promociones/promociones.module#PromocionesModule'
      // },
      {
        path:'reuniones',
        loadChildren: './operacion/reuniones/reuniones.module#ReunionesModule'
      },
      // {
      //   path: 'minoristas',
      //   loadChildren: './operacion/minoristas/minoristas.module#MinoristasModule'
      // },
      {
        path: 'catalogo',
        loadChildren: './catalogo/catalogo.module#CatalogoModule',
        canActivate: [ AuthGuard ]
      },
      {
        path: 'calendario',
        loadChildren: './operacion/calendario/calendario.module#CalendarioModule',
        canActivate: [ AuthGuard ]
      },
      {
        path: 'reuniones',
        loadChildren: './operacion/reuniones/reuniones.module#ReunionesModule'
      },
      // {
      //   path: 'generales',
      //   loadChildren: './operacion/generales/generales.module#GeneralesModule'
      // },
      {
        path: 'prospectos',
        loadChildren: './prospectos/prospectos.module#ProspectosModule'
      },
      {
        path:'chedraui',
        loadChildren: './homedepot/homedepot.module#HomeDepotModule',
        canActivate: [ AuthGuard ]
      },
      {
        path:'formatos-dinamicos',
        loadChildren: './formatos-dinamicos/formatos-dinamicos.module#FormatosDinamicosModule',
        canActivate: [ AuthGuard ]
      },
      {
        path:'usuarios',
        loadChildren: './usuarios/usuarios.module#UsuariosModule',
        canActivate: [ AuthGuard ]
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes), FormsModule, ReactiveFormsModule, SimpleNotificationsModule,
    NgxSpinnerModule, TabsModule.forRoot() ],
  exports: [ RouterModule ],
  declarations: [
    LoginComponent, LogoutComponent
  ],
  providers:[AuthGuard]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/app.routing.ts